export default {
  Home: 2,
  Mobile: 3,
  Work: 4
}